import { api } from '@/utils/api'

import { ApiResponseHandler, Gettable } from './ApiInterfaces'
import { ApiBase, ResponseError } from './ApiBase'

export namespace ApiTaRe290 {
  // API Name
  export const name: string = 'ApiTaRe290'

  // GET parameters
  export namespace Get {
    export const path: string = '/ta/testSchoolPassSubjects'

    export interface Request {
      query: {
        subjectCode: string
        grade: number
        fiscalYear: number
        testMonth: number
        testCountPerMonth?: number
        courseId: string
      }
    }

    export interface Response {
      results: {
        largePartNo: string
        smallPartNo: string
        difficultyLevel: string
        allocation: string
        score: string
        averageScore: string
      }[]
    }
  }

  // API本体
  export class Api extends ApiBase implements Gettable<Get.Request, Get.Response, ResponseError> {
    // GET
    public get<R>(
      params: Get.Request,
      successHandler: ApiResponseHandler<Get.Response, R>,
      errorHandler: ApiResponseHandler<ResponseError, R>
    ): Promise<R | null> {
      // 成功時のレスポンス構造サンプル
      const validationSample: Get.Response = {
        results: [
          {
            largePartNo: '',
            smallPartNo: '',
            difficultyLevel: '',
            allocation: '',
            score: '',
            averageScore: '',
          },
        ],
      }
      // エラー時のレスポンス構造サンプル
      const validationErrorSample: ResponseError = {
        error: {
          messageId: '',
          message: '',
        },
      }

      // API呼び出し
      return this.callbackWrapper<Get.Response, ResponseError, R>(
        api.get<Get.Response>(Get.path, { params: params.query }),
        successHandler,
        errorHandler,
        validationSample,
        validationErrorSample
      )
    }
  }
}
